import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TProductCartList, TProductOrderPayloadRequest, adaptAccountProductOrderIdListToRequest, adaptProductCartFromListResponse } from 'src/store';

import { useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_PRODUCT_ORDER } from '../../backend-paths';


export const accountProductOrderCreateApi = createAsyncThunk(
	`POST/${BACKEND_ACCOUNT_PRODUCT_ORDER}`,
	(payload: TProductOrderPayloadRequest, thunkApi) => {
		const dataRequest = adaptAccountProductOrderIdListToRequest(payload);

		return HttpService.post(BACKEND_ACCOUNT_PRODUCT_ORDER, dataRequest).then(result => {
			return adaptProductCartFromListResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	isLoading: boolean;
	list?: TProductCartList;
	error?: HttpError;
};

const initialState: TInitialState = {
	isLoading: false,
	list: undefined,
	error: undefined,
};

export const accountProductOrderCreateSlice = createSlice({
	name: 'accountProductOrderCreateSlice',
	initialState,
	reducers: {
		clearAccountProductOrderCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountProductOrderCreateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountProductOrderCreateApi.fulfilled.type]: (state, action: PayloadAction<TProductCartList>) => {
			state.isLoading = false;
			state.list = action.payload;
		},

		[accountProductOrderCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountProductOrderCreateSelector = () => useAppSelector(state => state[accountProductOrderCreateSlice.name]);

export const { clearAccountProductOrderCreate } = accountProductOrderCreateSlice.actions;
